import { CognitoUserPool } from "amazon-cognito-identity-js";

// new pool allowing email login
const poolData = {
  UserPoolId: "us-west-2_Dp3BbPakE",
  ClientId: "5dmrbviroffq7p87n2lgoojf4j"
}

export default new CognitoUserPool(poolData);
